import { get, writable } from "svelte/store";
export default class DimStore {
    static MAX_DIMS = 20;
    static MIN_DIMS = 1;
    store;
    constructor(init) {
        this.store = writable(init);
    }
    currentVal() {
        return get(this.store);
    }
    subscribe(cb) {
        return this.store.subscribe(cb);
    }
    inc() {
        this.set(this.currentVal() + 1);
    }
    dec() {
        this.set(this.currentVal() - 1);
    }
    set(dim) {
        if (dim > DimStore.MAX_DIMS || dim < DimStore.MIN_DIMS) {
            return;
        }
        this.store.set(dim);
    }
}
